import { Component } from '@angular/core';

@Component({
  selector: 'app-proxy-route',
  template: `<router-outlet></router-outlet>`,
})
export class ProxyRouteComponent {}
